import React, { useRef, useEffect, useCallback } from "react";

import styles from "../styles.css";
import { getHorizontalClip } from "../utils/overlayClip";

const MENU_BORDER = "1px solid var(--flw-forms-color, #1e87f0)";

// Flowable drops the border facing the control via react-select's placement, which our flip contradicts.
export const getMenuBorders = openUp => ({
	borderTop: openUp ? MENU_BORDER : "none",
	borderBottom: openUp ? "none" : MENU_BORDER,
});

const PortalSelect = ({ SelectComponent, ...props }) => {
	const ref = useRef(null);

	const reposition = useCallback(() => {
		if (!ref.current) {
			return;
		};
		const menu = ref.current.querySelector(".flw__select__menu");
		const control = ref.current.querySelector(".flw__select__control");
		if (!menu || !control) {
			return;
		};
		const element = control.getBoundingClientRect();
		const menuH = menu.scrollHeight;
		const spaceBelow = window.innerHeight - element.bottom;
		const openUp = spaceBelow < menuH && element.top > spaceBelow;

		const bounds = control.closest(`.${styles.dataTableScrollWrapper}`)?.getBoundingClientRect();

		Object.assign(menu.style, {
			position: "fixed",
			width: `${element.width}px`,
			left: `${element.left}px`,
			zIndex: "9999",
			top: openUp ? "auto" : `${element.bottom}px`,
			bottom: openUp ? `${window.innerHeight - element.top}px` : "auto",
			clipPath: getHorizontalClip(bounds, element.left, element.width),
			...getMenuBorders(openUp),
		});
	}, []);

	useEffect(() => {
		const element = ref.current;
		if (!element) {
			return;
		};
		const observer = new MutationObserver(reposition);
		observer.observe(element, { childList: true, subtree: true });
		window.addEventListener("scroll", reposition, true);
		window.addEventListener("resize", reposition);

		return () => {
			observer.disconnect();
			window.removeEventListener("scroll", reposition, true);
			window.removeEventListener("resize", reposition);
		};
	}, [ reposition ]);

	return <div ref={ref}><SelectComponent {...props} /></div>;
};

export default PortalSelect;
